import type { FC } from 'react';
import { Box, Typography } from '@mui/material';

interface ContextErrorProps {
  /** Error message to display */
  message: string;
}

/**
 * Renders a centered error message with standardized styling.
 */
const ContextError: FC<ContextErrorProps> = ({ message }) => (
  <Box sx={{ textAlign: 'center', p: 4 }}>
    <Typography variant="h6" color="error" gutterBottom>
      {message}
    </Typography>
  </Box>
);

export default ContextError;